<!-- =========================================================================================
  File Name: DesignEdit.vue
  Description: Design Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/design/pixinvent
========================================================================================== -->

<template>
  <div id="page-design-edit">

    <vs-alert color="danger" title="Design Not Found" :active.sync="design_not_found">
      <span>Design record with id: {{ $route.params.designId }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'page-design-list'}" class="text-inherit underline">All Designs</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="design_data">

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Account" icon-pack="feather" icon="icon-design">
            <div class="tab-text">
              <design-edit-tab-account class="mt-4" :data="design_data" />
            </div>
          </vs-tab>
          <vs-tab label="Information" icon-pack="feather" icon="icon-info">
            <div class="tab-text">
              <design-edit-tab-information class="mt-4" :data="design_data" />
            </div>
          </vs-tab>
          <vs-tab label="Social" icon-pack="feather" icon="icon-share-2">
            <div class="tab-text">
              <design-edit-tab-social class="mt-4" :data="design_data" />
            </div>
          </vs-tab>
        </vs-tabs>

      </div>

    </vx-card>
  </div>
</template>

<script>
import DesignEditTabAccount     from './DesignEditTabAccount.vue'
import DesignEditTabInformation from './DesignEditTabInformation.vue'
import DesignEditTabSocial      from './DesignEditTabSocial.vue'

// Store Module
import moduleDesignManagement from '@/store/design-management/moduleDesignManagement.js'

export default {
  components: {
    DesignEditTabAccount,
    DesignEditTabInformation,
    DesignEditTabSocial
  },
  data () {
    return {
      design_data: null,
      design_not_found: false,

      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeTab: 0
    }
  },
  watch: {
    activeTab () {
      this.fetch_design_data(this.$route.params.designId)
    }
  },
  methods: {
    fetch_design_data (designId) {
      this.$store.dispatch('designManagement/fetchDesign', designId)
        .then(res => { this.design_data = res.data })
        .catch(err => {
          if (err.response.status === 404) {
            this.design_not_found = true
            return
          }
          console.error(err) 
        })
    }
  },
  created () {
    // Register Module DesignManagement Module
    if (!moduleDesignManagement.isRegistered) {
      this.$store.registerModule('designManagement', moduleDesignManagement)
      moduleDesignManagement.isRegistered = true
    }
    this.fetch_design_data(this.$route.params.designId)
  }
}

</script>
